import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store'
import '@/libs/wechat-signature'
import * as filters from '@/filters' // 全局过滤器
import { Toast, Button, Cell, Icon, Col, Row } from 'vant' // 全局引入部分组件
import { setToken } from "@/libs/cookie-storage";

import './assets/css/variables.scss'
import './assets/css/questionnaire-theme.scss'
// import VConsole from 'vconsole'
// const vConsole = new VConsole()
// Vue.use(vConsole)
import store from './store'
import './permission' // permission control
import i18n from './locales' // 国际化配置

Toast.setDefaultOptions({
  duration: 2000,
  className: 'custom-toast' // 可以添加自定义类名
})


Vue.config.ignoredElements = ['wx-open-launch-weapp']

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.use(Toast).use(Button).use(Cell).use(Icon).use(Col).use(Row)
Vue.config.productionTip = false

import directives from './directives'
Vue.use(directives)

// eslint-disable-next-line
router.afterEach((to, from, next) => {
  if (to.query.passport) {
    setToken(to.query.passport)
  }
  window.scrollTo(0, 0)
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
